exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ul-list{padding:0;margin-bottom:0;margin-right:-5px;margin-left:-5px}.ul-list li{list-style-type:none;letter-spacing:-.75px;padding-right:5px;padding-left:5px}.ul-list li:before{content:\"\\2022\";font-size:inherit;margin-right:2px;display:inline-block}.locationsList-container{overflow:hidden;background:transparent}.locationsList-container .list-scroll{position:relative;overflow:auto;max-height:320px;margin:0 -10px 0 -5px}.locationsList-container .list-scroll .ul-list{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader/src!./~/less-loader!./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/entity/LocationsList/index.less
// module id = 1984
// module chunks = 0